module.exports = __webpack_public_path__ + "assets/img/2_810.5e5123a3.jpg";